import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { api, fileUrl } from "@/lib/api";
import { CreativeCard, CreativeDialog } from "@/components/Creative";
import { SectionTitle, EmptyExample } from "@/components/Primitives";
import { cn } from "@/lib/utils";

const FILTERS = [["", "Everything"], ["social", "Posts"], ["ads", "Ads"], ["website", "Website"]];

export default function Library() {
  const [filter, setFilter] = useState("");
  const [open, setOpen] = useState(null);
  const { data } = useQuery({ queryKey: ["assets"], queryFn: async () => (await api.get("/assets")).data });
  const assets = (data || []).filter((a) => !filter || a.module === filter);
  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-10 sm:py-14 space-y-8" data-testid="library-page">
      <SectionTitle eyebrow="Library" title="Everything you've made." body="Every finished creative with its copy blocks. Filters and bulk download arrive in the next phase." action={
        <div className="flex gap-1 p-1 rounded-full border border-border">{FILTERS.map(([k, l]) => <button key={k} type="button" onClick={() => setFilter(k)} data-testid={`library-filter-${k || "all"}`} className={cn("px-3 h-8 rounded-full text-xs transition-colors", filter === k ? "bg-foreground text-background" : "text-muted-foreground hover:text-foreground")}>{l}</button>)}</div>
      } />
      {data && assets.length === 0 ? (
        <EmptyExample title="Your library fills itself" body="Launch your kit and every post, ad and website lands here — ready to copy, download and reuse." image="https://images.unsplash.com/photo-1759960034333-298883b34d3d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" cta={<Link to="/launch" className="btn-outline w-fit">Open Launch Kit</Link>} />
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6" data-testid="library-grid">
          {assets.map((a) => a.kind === "website" ? (
            <Link key={a.id} to="/launch" className="card-lux overflow-hidden" data-testid="library-website-card"><div className="aspect-square relative bg-muted">{a.thumbnail_url && <img src={fileUrl(a.thumbnail_url)} alt="" className="absolute inset-0 h-full w-full object-cover" />}<span className="absolute left-3 top-3 eyebrow-label !text-[9px] bg-background/80 glass px-2 py-1 rounded">Website · {a.status}</span></div><div className="p-4 text-sm font-medium">{a.title}</div></Link>
          ) : <CreativeCard key={a.id} asset={a} onOpen={setOpen} label={a.module === "ads" ? "Ad" : undefined} />)}
        </div>
      )}
      <Link to="/compose" className="btn-outline">Compose a post from a photo</Link>
      <CreativeDialog asset={open} onClose={() => setOpen(null)} />
    </div>
  );
}
